import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { EstadoCivil } from '../../models/estado-civil/estado-civil';

@Injectable({
  providedIn: 'root',
})
export class EstadosCivilesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.ESTADOS_CIVILES}`;
  constructor(private http: HttpClient) {}

  getEstadosCiviles(): Observable<EstadoCivil[]> {
    return this.http.get<EstadoCivil[]>(this.apiUrl);
  }
}
